import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const switchChipGroupStylesObject = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

type SwitchChipStylesProps = {
  isNew?: boolean;
  selected: boolean;
  disabled?: boolean;
};

const switchChipStyles = ({ isNew, selected, disabled }: SwitchChipStylesProps) =>
  isNew
    ? [
        { transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out' },
        selected && {
          cursor: 'pointer',
          backgroundColor: theme.colors.primary5,
          border: '1px solid transparent',
          color: theme.colors.neutral90,
        },
        !selected && {
          cursor: 'pointer',
          border: `1px solid ${theme.colors.neutral50}`,
          color: theme.colors.neutral90,
          '&:hover': {
            backgroundColor: theme.colors.neutral10,
            border: `1px solid transparent`,
          },
        },
        disabled &&
          selected && {
            cursor: 'not-allowed',
            background: theme.colors.primary5,
            color: theme.colors.neutral90,
          },
        disabled &&
          !selected && {
            cursor: 'not-allowed',
            background: theme.colors.neutral5,
            border: `1px solid ${theme.colors.neutral20}`,
            color: theme.colors.neutral90,
          },
      ]
    : [
        css`
          max-width: 144px;
        `,
        selected
          ? [
              css`
                transition: background-color 0.2s ease-in-out;
                background-color: ${theme.colors.primary50};
                color: ${theme.colors.white};
                border: 1px solid ${theme.colors.primary50};
              `,
              disabled
                ? css`
                    background-color: ${theme.colors.primary20};
                  `
                : css`
                    cursor: pointer;
                    :hover {
                      background-color: ${theme.colors.primary60};
                    }
                  `,
            ]
          : [
              css`
                transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
              `,
              disabled
                ? css`
                    border-color: ${theme.colors.neutral20};
                    color: ${theme.colors.neutral20};
                  `
                : css`
                    cursor: pointer;
                    :hover {
                      background-color: ${theme.colors.neutral10};
                      border-color: ${theme.colors.neutral10};
                    }
                  `,
            ],
      ].flat();

export const SwitchChipGroupStyles = {
  switchGroup: switchChipGroupStylesObject,
  switchChip: (props: SwitchChipStylesProps) => switchChipStyles(props),
};
